import { render, staticRenderFns } from "./NearMissIncidents.vue?vue&type=template&id=3c9d2a94&"
import script from "./NearMissIncidents.vue?vue&type=script&lang=js&"
export * from "./NearMissIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports